module.exports = __webpack_public_path__ + "media/Flesh_extract.8d3e23e1.mp3";